import { useCallback, useEffect, useState } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { DynamicFieldStorageTypes } from '../_types/dynamicFieldStorage.types';
import { USER_DATA_KEY } from '../constantes/LocalStorageEnum';

export const useDynamicFieldsStorage = () => {
  const [registrationData, setRegistrationData] = useState<DynamicFieldStorageTypes>({
    additionalInfo: null,
    addressInfo: null,
    contactInfo: null,
    personalInfo: null,
    complementaryInfo: null
  });
  
  const loadStorageData = useCallback(() => {
    const data: DynamicFieldStorageTypes = {
      additionalInfo: ApiLocalStorage.get('additionalInfo'),
      addressInfo: ApiLocalStorage.get('address'),
      contactInfo: ApiLocalStorage.get('contact'),
      personalInfo: ApiLocalStorage.get('personal'),
      complementaryInfo: ApiLocalStorage.get('complementaryStep')
    };
    
    setRegistrationData(data);
    
    return data;
  }, []);
  
  const clearStorageData = useCallback(() => {
    // Limpar dados do formulário dinâmico
    ApiLocalStorage.remove('additionalInfo');
    ApiLocalStorage.remove('address');
    ApiLocalStorage.remove('contact');
    ApiLocalStorage.remove('personal');
    ApiLocalStorage.remove('complementaryStep');
    
    // Limpar outros dados que podem conter informações antigas
    ApiLocalStorage.remove(USER_DATA_KEY);
    
    setRegistrationData({
      additionalInfo: null,
      addressInfo: null,
      contactInfo: null,
      personalInfo: null,
      complementaryInfo: null
    });
  }, []);
  
  const updateStorageData = useCallback((key: keyof DynamicFieldStorageTypes, data: any) => {
    const storageKey = key === 'addressInfo' ? 'address' : 
                      key === 'complementaryInfo' ? 'complementaryStep' : key;
    ApiLocalStorage.set(storageKey, data);
    
    setRegistrationData(prev => ({
      ...prev,
      [key]: data
    }));
  }, []);
  
  const getUserContactData = useCallback(() => {
    const contactData = registrationData.contactInfo || {};
    
    return {
      email: contactData.email || '',
      phoneNumber: contactData.phoneNumber || ''
    };
  }, [registrationData]);
  
  useEffect(() => {
    loadStorageData();
  }, [loadStorageData]);
  
  return {
    registrationData,
    loadStorageData,
    clearStorageData,
    updateStorageData,
    getUserContactData
  };
};
